if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        const productCategoryInput = this.form.querySelector('[name="product_category"]');
        this.productCategory = productCategoryInput ? productCategoryInput.value : '';
        
        //console.log('Product Category:', this.productCategory);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const locale = document.documentElement.lang;
        //console.log('locale:', locale);

        const translations = {
          'en': {
            custom: {
              quantity_error: 'Each pastry flavor requires a minimum of 3 items.',
              file_count_error: 'Only one file can be uploaded at a time. If you need multiple designs for the same item, please add to cart and select again.',
              file_type_error: 'We only accept JPG or PNG file formats.',
              file_size_error: 'The file must be 10MB or less.'
            }
          },
          'zh-TW': {
            custom: {
              quantity_error: '每款鬆餅口味最少需要選擇3個。',
              file_count_error: '每次只能選擇一個檔案，如同一茶款需要多於一款圖案，請先加入購物車再重新選擇。',
              file_type_error: '我們只接受JPG或PNG的檔案格式。',
              file_size_error: '檔案需要為10MB或以下。'
            }
          }
        }[locale];

        let quantityInput = document.querySelector(".quantity__input");
        this.productQuantity = quantityInput ? quantityInput.value : '';
        //console.log('Product quantity:', this.productQuantity);
        if ((this.productCategory === 'Pastries & Scones' || this.productCategory === '糕點/司康') && this.productQuantity < 3) {
          this.handleErrorMessage(translations.custom.quantity_error)
          return;
        }
        
        // Validate file upload
        const fileInput = this.querySelector('#package-icon-upload');
        const maxFileSize = 10 * 1024 * 1024; // 10 MB in bytes
        if (fileInput && fileInput.files.length > 0) {
          const files = fileInput.files;
          if (files.length > 1) {
            this.handleErrorMessage(translations.custom.file_count_error);
            return;
          }
          for (let file of files) {
            if (!file.type.match('image/(jpeg|png)')) {
              this.handleErrorMessage(translations.custom.file_type_error);
              return;
            }
            
            if (file.size > maxFileSize) {
              this.handleErrorMessage(translations.custom.file_size_error);
              return;
            }
          }
        }
        
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
